import React, { Fragment, useEffect, useReducer } from 'react'
import { ScrollableTabs } from '../../components/Tabs/ScrollableTabsV2'
import {
  Configuration,
  ConfigurationTab
} from '../../interfaces/Configuration/Configuration'
import {
  configurationTab,
  EnumConfigurationTab
} from '../../utils/configurationTab'
import { Configurations } from '../../components/Configuration/Configurations'
import {
  configurationReducer,
  reducerInitialState
} from '../../components/Configuration/configurationReducer'
import { ConfigurationContext } from '../../components/Configuration/configurationContext'
import { apiCall, ApiConfig } from '../../config/api'
import { TypeProcess } from '../../interfaces/TypeProcess/TypeProcess'
import { useConfiguration } from '../../hooks/useConfiguration'
import { useTypePosition } from '../../hooks'

interface ConfigurationPageProps {}

export const ConfigurationPage: React.FC<ConfigurationPageProps> = () => {
  const [state, dispatch] = useReducer(
    configurationReducer,
    reducerInitialState
  )

  const { getConfiguration } = useConfiguration()
  const { getTypePositions} = useTypePosition()

  const { loading, parameters, typeConfiguration, typeProcess, inputValue } =
    state

  const initializeStateForKeys = (data: any, typeConfigurationId: number) => {
    const initialState = {}
    if (typeConfigurationId === EnumConfigurationTab.PARAMETROS) {
      data.map((data: any) => {
        return (initialState[data.name] =
          data.value === null || data.value === 'null' || data.value === ''
            ? ''
            : data.value)
      })
    } else {
      data.map((data: any) => {
        return (initialState[data.name] = data.urlProcess)
      })
    }

    dispatch({ type: 'SET_INPUT_VALUE', payload: initialState })
  }

  const editModeButtons = (name: any, isEditable: boolean) => {
    const btnEdit = document.getElementById(`edit${name}`)!
    const btnCancel = document.getElementById(`cancel${name}`)!
    const btnSave = document.getElementById(`save${name}`)!
    const btnInfo = document.getElementById(`info${name}`)!

    if (isEditable) {
      dispatch({ type: 'SET_INPUT_NAME', payload: name })
      btnEdit.style.display = 'none'
      btnCancel.style.display = '-webkit-inline-flex'
      btnSave.style.display = '-webkit-inline-flex'
    } else {
      dispatch({ type: 'SET_INPUT_NAME', payload: '' })
      btnEdit.style.display = '-webkit-inline-flex'
      btnCancel.style.display = 'none'
      btnSave.style.display = 'none'
      btnCancel.style.top = '0px'
      btnInfo.style.top = '0px'
    }
  }

  const saveModeButtons = (name: any, isCreated: boolean) => {
    const btnEdit = document.getElementById(`edit${name}`)!
    const btnCancel = document.getElementById(`cancel${name}`)!
    const btnSave = document.getElementById(`save${name}`)!
    const btnInfo = document.getElementById(`info${name}`)!
    const loaderSave = document.getElementById(`loader${name}`)!
    if (isCreated) {
      dispatch({ type: 'SET_INPUT_NAME', payload: '' })
      btnCancel.style.pointerEvents = 'none'
      btnCancel.style.color = 'rgba(0, 0, 0, 0.20)'
      btnCancel.style.display = '-webkit-inline-flex'
      btnCancel.style.top = '2px'
      btnSave.style.pointerEvents = 'none'
      btnSave.style.color = 'rgba(0, 0, 0, 0.20)'
      btnInfo.style.top = '2px'
      loaderSave.style.visibility = 'visible'
    } else {
      dispatch({ type: 'SET_INPUT_NAME', payload: '' })
      btnEdit.style.display = '-webkit-inline-flex'
      btnSave.style.pointerEvents = 'auto'
      btnSave.style.display = 'none'
      btnSave.style.color = 'rgba(0, 0, 0, 0.54)'
      btnCancel.style.pointerEvents = 'auto'
      btnCancel.style.top = '0px'
      btnCancel.style.display = 'none'
      btnCancel.style.color = 'rgba(0, 0, 0, 0.54)'
      btnInfo.style.top = '0px'
      loaderSave.style.visibility = 'hidden'
    }
  }

  const handleConfigurationOrTypeProcess = (typeConfigurationId: number) => {
    dispatch({ type: 'SET_LOADING', payload: true })
    setTimeout(() => {
      dispatch({ type: 'SET_TYPE_CONFIGURATION', payload: typeConfigurationId })

      if (typeConfigurationId === EnumConfigurationTab.PARAMETROS) {
        apiCall('GET', `${ApiConfig.ConfigurationApi}/Get`)
          .then((response) => {
            dispatch({ type: 'SET_PARAMETERS', payload: response.data })
            initializeStateForKeys(response.data, typeConfigurationId)
          })
          .catch((error) => {
            console.log(error)
          })
      } else {
        apiCall('GET', `${ApiConfig.TypeProcessApi}/Get`)
          .then((response) => {
            dispatch({ type: 'SET_TYPE_PROCESS', payload: response.data })
            initializeStateForKeys(response.data, typeConfigurationId)
          })
          .catch((error) => {
            console.log(error)
          })
      }
      dispatch({ type: 'SET_LOADING', payload: false })
    }, 1500)
  }

  const handleUpdateConfiguration = (
    typeConfigurationOrProcessId: number,
    name: string,
    isCheck?: boolean
  ) => {
    const alertConfiguration = document.getElementById(
      `alertConfiguration${name}`
    )!

    if (typeConfiguration === EnumConfigurationTab.PARAMETROS) {
      const param = parameters.filter(
        (x: Configuration) =>
          x.name === name &&
          x.typeConfigurationId === typeConfigurationOrProcessId
      )

      const configurationUpdateDto = {
        typeConfigurationId: param[0].typeConfigurationId,
        name: param[0].name,
        value: inputValue[`${name}`]
      }

      apiCall(
        'PUT',
        `${ApiConfig.ConfigurationApi}/Put`,
        configurationUpdateDto
      )
        .then((response) => {
          dispatch({ type: 'SET_STATUS_CODE', payload: response.status })

          alertConfiguration.style.visibility = 'visible'
          getConfiguration()
          getTypePositions()
        })
        .catch((error) => {
          // dispatch({ type: 'SET_STATUS_CODE', payload: error.status })
          dispatch({
            type: 'SET_MESSAGE_SERVER',
            payload: error.data
          })

          alertConfiguration.style.visibility = 'visible'

          // si es un checkbox y da error, vuelve al valor anterior
          if (isCheck) {
            dispatch({
              type: 'SET_INPUT_VALUE',
              payload: {
                ...inputValue,
                [`${name}`]: param[0].value
              }
            })
          }
        })
    } else {
      const typeProc = typeProcess.filter(
        (x: TypeProcess) =>
          x.name === name && x.typeProcessId === typeConfigurationOrProcessId
      )

      const typeProcessDto = {
        typeProcessId: typeProc[0].typeProcessId,
        typeProcessGlobalId: typeProc[0].typeProcessGlobalId,
        name: typeProc[0].name,
        description: typeProc[0].description,
        urlProcess: inputValue[`${name}`],
        active: typeProc[0].active
      }

      apiCall('PUT', `${ApiConfig.TypeProcessApi}/Put`, typeProcessDto)
        .then((response) => {
          dispatch({ type: 'SET_STATUS_CODE', payload: response.status })
          alertConfiguration.style.visibility = 'visible'
        })
        .catch(() => {
          dispatch({ type: 'SET_STATUS_CODE', payload: 500 })
          dispatch({
            type: 'SET_MESSAGE_SERVER',
            payload: 'Error al modificar parámetro.'
          })
        })
    }
    dispatch({ type: 'SET_LOADING', payload: false })

    setTimeout(() => {
      alertConfiguration.style.visibility = 'hidden'
    }, 4000)
  }

  const handleChange = (e: any) => {
    dispatch({
      type: 'SET_INPUT_VALUE',
      payload: { ...inputValue, [e.target.name]: e.target.value }
    })
  }

  useEffect(() => {
    handleConfigurationOrTypeProcess(EnumConfigurationTab.PARAMETROS)
  }, [])

  return (
    <ConfigurationContext.Provider
      value={{
        state,
        dispatch,
        handleUpdateConfiguration,
        handleChange,
        editModeButtons,
        saveModeButtons
      }}
    >
      <Fragment>
        <ScrollableTabs
          isLoading={loading}
          entity={configurationTab.map((x: ConfigurationTab) => ({
            id: x.id,
            entity: x.name
          }))}
          rowsLength={configurationTab.length}
          child={<Configurations />}
          onClick={(typeConfigurationId: number) =>
            handleConfigurationOrTypeProcess(typeConfigurationId)
          }
        />
      </Fragment>
    </ConfigurationContext.Provider>
  )
}
